import { Route, Switch } from 'react-router-dom';
import MyUtil from '../../functions/MyUtil';
import React from 'react';
import ListTestimonial from './ListTestimonial';
import FormTestimonial from './FormTestimonial';

const Testimonial = (props) => {
  const {
    match,
    match: { url },
  } = props;
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(url, 'view') && (
          <Route
            exact
            path={`${url}`}
            component={() => <ListTestimonial match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(url, 'add') && (
          <Route path={`${url}/add-testimonial`} component={FormTestimonial} />
        )}
        {MyUtil.hasPermission(url, 'update') && (
          <Route path={`${url}/edit-testimonial/:id`} component={FormTestimonial} />
        )}
      </Switch>
    </div>
  );
};

export default Testimonial;
